import { css } from "@emotion/react";

export const content = css`
  padding: 0 15px 15px;
  display: flex;
  gap: 20px;
  flex-grow: 1;
  flex-direction: column;
  position: relative;
`;
